import React, { useCallback, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField';
import { buildPrimaryLayout, CollectionCreditTypeOptions, CollectionCreditStatusOptions } from '../Layout';
import { EMPTY_GUID, FORM_LAYOUTS } from '../constants';

function PrimaryTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const loadLookupClient = useCallback((name, dataSource, valueExpr = 'id', displayExpr = 'text') => {
        if (!props.formRefs?.current?.[name]) return;
        const ref = props.formRefs.current[name];
        if (!ref?.instance) return;
        // ref.instance is the accessor function - it can still return undefined if the
        // underlying DevExtreme widget isn't (or is no longer) actually mounted, e.g. right
        // after its tab's content was torn down/rebuilt.
        const instance = ref.instance();
        if (!instance) return;

        instance.option('dataSource', dataSource);
        instance.option('valueExpr', valueExpr);
        instance.option('displayExpr', displayExpr);

        const currentValue = props.formFields?.[name];
        if (currentValue !== undefined) {
            instance.option('value', currentValue);
        }
    }, [props.formRefs, props.formFields]);

    // ARD0009 locks the Customer lookup once the header exists - see buildPrimaryLayout.
    const isSavedHeader = !!props.formFields?.ROWID && props.formFields.ROWID !== EMPTY_GUID;

    const finalLayout = useMemo(() => {
        return buildPrimaryLayout({ customerReadOnly: isSavedHeader });
    }, [isSavedHeader]);

    const handleSelectionChange = useCallback((name, value, e) => {
        props.handleFieldChange(name, value, e);
    }, [props.handleFieldChange]);

    const handlePrimaryFormLoad = useCallback(() => {
        setTimeout(() => {
            loadLookupClient("TYPE", CollectionCreditTypeOptions);
            loadLookupClient("STATUS", CollectionCreditStatusOptions);
        }, 100);
    }, [loadLookupClient]);

    useEffect(() => {
        loadLookupClient("TYPE", CollectionCreditTypeOptions);
    }, [loadLookupClient, props.formFields?.TYPE]);

    useEffect(() => {
        loadLookupClient("STATUS", CollectionCreditStatusOptions);
    }, [loadLookupClient, props.formFields?.STATUS]);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId={FORM_LAYOUTS.Primary.id}
                layoutName={FORM_LAYOUTS.Primary.name}
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleSelectionChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handlePrimaryFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(PrimaryTab);
